import React, { useState, useCallback } from "react";
import {
	SettingToggle,
	TextStyle,
	Card,
	Banner,
	Badge,
} from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings } from "../../actions/index";
import config from "../../config/config";
import { NotificationMajor, SecureMajor } from "@shopify/polaris-icons";
const DigitalProduct = () => {
	const dispatch = useDispatch();
	const dataSettings = useSelector((state) => state.dataSettings);

	const handleToggle = useCallback(() => {
		if (config.role !== "view") {
			let newDigitalProduct =
				dataSettings.sync_digital_product === "0" ? "1" : "0";
			let params = {
				action: "updateDigitalProduct",
				digitalProduct: newDigitalProduct,
			};
			callApi("get", params, "services.php").then(function (response) {
				if (response.data.state === 1) {
					let newDataSettings = { ...dataSettings };
					newDataSettings.sync_digital_product = newDigitalProduct;
					dispatch(actFetchDataSettings(newDataSettings));
				}
			});

			let newDataSettings = { ...dataSettings };
			newDataSettings.sync_digital_product = dispatch(
				actFetchDataSettings(newDataSettings)
			);
		}
	}, [dataSettings, dispatch]);

	const contentStatus =
		dataSettings.sync_digital_product === "1" ? "Turn off" : "Turn on";
	const textStatus =
		dataSettings.sync_digital_product === "1" ? (
			<Badge status="success" progress="complete">
				ON
			</Badge>
		) : (
			<Badge status="critical" progress="complete">
				OFF
			</Badge>
		);

	return (
		<div style={{ marginTop: "20px" }} className="notify buyer-page">
			<Card sectioned>
				<Banner
					status="success"
					icon={SecureMajor}
					title="Sync digital product"
				>
					<div className="mt-3">
						<SettingToggle
							action={{
								content: contentStatus,
								onAction: handleToggle,
							}}
							enabled={
								dataSettings.sync_digital_product === "0"
									? false
									: true
							}
						>
							Sync tracking numbers to PayPal and Stripe for
							digital product orders (shipping not required):{" "}
							<TextStyle variation="strong">
								{textStatus}
							</TextStyle>
						</SettingToggle>
					</div>
				</Banner>
			</Card>
		</div>
	);
};

export default DigitalProduct;
